import img from '../images/404.svg'

export const Page404 = () => {
    return (<div className="page404">
        <img src={img} alt="404" title="404"/>
    </div>)
}